
// import React, { useEffect, useState } from 'react';
// import { useSearchParams } from 'react-router-dom';
// import { customerAPI } from '../services/api';
// import { Typography } from 'antd';
// const { Title, Text } = Typography;

// const BookingAgreement = () => {
//   const [searchParams] = useSearchParams();
//   const bookingId = searchParams.get('bookingId');
// //   const bookingId = 'b6624940-fb09-4205-b9e8-b0e698eb9aca';

//   const [loading, setLoading] = useState(true);
//   const [agreementUrl, setAgreementUrl] = useState('');
//   const [signedUrl, setSignedUrl] = useState('');
//   const [error, setError] = useState('');

//   const [file, setFile] = useState(null);
//   const [uploading, setUploading] = useState(false);
//   const [success, setSuccess] = useState('');

//   useEffect(() => {
//     if (!bookingId) {
//       setError('Booking ID not provided');
//       setLoading(false);
//       return;
//     }

//     const fetchAgreement = async () => {
//       try {
//         const res = await customerAPI.getBookingAgreement(bookingId);

//         setAgreementUrl(res.data.data.bookingAgreementUrl);
//         setSignedUrl(res.data.data.signedAgreementUrl);
//       } catch (err) {
//         console.error(err);
//         setError('Failed to load booking agreement');
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchAgreement();
//   }, [bookingId]);

//   // ✅ Handle file upload
//   const handleUpload = async () => {
//     if (!file) {
//       alert('Please select a signed agreement PDF');
//       return;
//     }

//     try {
//       setUploading(true);
//       setError('');
//       setSuccess('');

//       const res = await customerAPI.uploadSignedAgreement(bookingId, file);

//       setSuccess('Signed agreement uploaded successfully ✅');

//       // ✅ Refresh signed PDF preview
//       if (res?.data?.signedAgreementUrl) {
//         setSignedUrl(res.data.signedAgreementUrl);
//       }
//     } catch (err) {
//       console.error(err);
//       setError('Failed to upload signed agreement');
//     } finally {
//       setUploading(false);
//     }
//   };

//   if (loading) return <div>Loading agreement...</div>;

//   return (
//     <div style={{ padding: 20 }}>
//       <h2>Booking Agreement</h2>
//       <div className="catalog-header">
//         <div className="catalog-header-content">
//           <Title level={2} className="catalog-title">
//             Xoom Drives
//           </Title>

//         </div>
//       </div>
//       {error && <p style={{ color: 'red' }}>{error}</p>}
//       {success && <p style={{ color: 'green' }}>{success}</p>}

//       {/* Agreement preview */}
//       {agreementUrl && (
//         <>
//           <h4>Agreement Preview</h4>

//           <iframe
//             src={agreementUrl}
//             title="Booking Agreement"
//             width="100%"
//             height="600px"
//             style={{ border: '1px solid #ddd', borderRadius: 8 }}
//           />

//           <p>
//             <a href={agreementUrl} target="_blank" rel="noopener noreferrer">
//               Download Agreement PDF
//             </a>
//           </p>
//         </>
//       )}

//       {/* Upload signed agreement */}
//       <h4>Upload Signed Agreement</h4>

//       <input
//         type="file"
//         accept="application/pdf"
//         onChange={(e) => setFile(e.target.files[0])}
//       />

//       <br />

//       <button
//         onClick={handleUpload}
//         disabled={uploading}
//         style={{ marginTop: 10, padding: '8px 16px' }}
//       >
//         {uploading ? 'Uploading...' : 'Upload Signed PDF'}
//       </button>

//       {/* Signed PDF preview */}
//       {signedUrl && (
//         <>
//           <h4 style={{ marginTop: 30 }}>Signed Agreement</h4>

//           <iframe
//             src={signedUrl}
//             title="Signed Agreement"
//             width="100%"
//             height="600px"
//             style={{ border: '1px solid #ddd', borderRadius: 8 }}
//           />

//           <p>
//             <a href={signedUrl} target="_blank" rel="noopener noreferrer">
//               Download Signed PDF
//             </a>
//           </p>
//         </>
//       )}
//     </div>
//   );
// };

// export default BookingAgreement;


import React, { useEffect, useState, useCallback } from 'react';
import { useSearchParams, useParams } from 'react-router-dom';
import { customerAPI } from '../services/api';
import {
    Typography,
    Card,
    Button,
    Upload,
    Alert,
    Spin,
    Space,
    Row,
    Col,
} from 'antd';
import { UploadOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

const IFRAME_HEIGHT = 550;

const BookingAgreement = () => {
    const [searchParams] = useSearchParams();
    const { id: pathId } = useParams();
    const bookingId = pathId || searchParams.get('bookingId');

    const [loading, setLoading] = useState(true);
    const [agreementUrl, setAgreementUrl] = useState('');
    const [signedUrl, setSignedUrl] = useState('');
    const [error, setError] = useState('');
    const [file, setFile] = useState(null);
    const [uploading, setUploading] = useState(false);
    const [success, setSuccess] = useState('');

    // ✅ SINGLE GET FLOW (Reusable)
    const fetchAgreement = useCallback(async () => {
        if (!bookingId) return;

        try {
            setLoading(true);
            const res = await customerAPI.getBookingAgreement(bookingId);

            setAgreementUrl(res.data?.data?.bookingAgreementUrl || '');
            setSignedUrl(res.data?.data?.signedAgreementUrl || '');
        } catch {
            setError('Failed to load booking agreement');
        } finally {
            setLoading(false);
        }
    }, [bookingId]);

    useEffect(() => {
        if (!bookingId) {
            setError('Booking ID not provided');
            setLoading(false);
            return;
        }
        fetchAgreement();
    }, [bookingId, fetchAgreement]);

    // ✅ Upload and REFRESH GET
    const handleUpload = async () => {
        if (!file) return setError('Please select a signed agreement PDF');

        try {
            setUploading(true);
            setError('');
            setSuccess('');

            await customerAPI.uploadSignedAgreement(bookingId, file);

            setFile(null);
            setSuccess('Signed agreement uploaded successfully ✅');

            // ✅ REFRESH BOTH PREVIEWS
            await fetchAgreement();
        } catch {
            setError('Failed to upload signed agreement');
        } finally {
            setUploading(false);
        }
    };

    if (loading) {
        return (
            <div style={{ textAlign: 'center', padding: 80 }}>
                <Spin size="large" />
                <p style={{ marginTop: 12 }}>Loading agreement…</p>
            </div>
        );
    }

    return (
        <div style={{ maxWidth: 1700, margin: 'auto', padding: 10 }}>
            <Card
                bordered={false}
                style={{
                    borderRadius: 12,
                    boxShadow: '0px 6px 18px rgba(0,0,0,0.06)',
                }}
            >
                <div className="catalog-header">
                    <div className="catalog-header-content">
                        <img
                            src="/logo.png"
                            alt="Xoom Drives"
                            style={{ height: 60, marginBottom: 8 }}
                        />

                    </div>
                </div>

                {error && (
                    <Alert style={{ marginBottom: 16 }} type="error" showIcon message={error} />
                )}

                {success && (
                    <Alert
                        style={{ marginBottom: 16 }}
                        type="success"
                        showIcon
                        message={success}
                    />
                )}

                <Row gutter={24} align="stretch">
                    {/* ---------------- LEFT ---------------- */}
                    <Col xs={24} md={12}>
                        <Card
                            size="small"
                            title="Agreement Preview"
                            style={{ height: '100%' }}
                        >
                            {/* IFRAME */}
                            <div style={{ height: IFRAME_HEIGHT }}>
                                {agreementUrl ? (
                                    <iframe
                                        src={agreementUrl}
                                        title="Agreement"
                                        width="100%"
                                        height={IFRAME_HEIGHT}
                                        style={{
                                            border: '1px solid #E5E7EB',
                                            borderRadius: 8,
                                        }}
                                    />
                                ) : (
                                    <Text type="secondary">No agreement available</Text>
                                )}
                            </div>

                            {/* DOWNLOAD (ALIGNED) */}
                            <div style={{ textAlign: 'center', marginTop: 10 }}>
                                <Button
                                    type="primary"
                                    ghost
                                    size="large"
                                    href={agreementUrl}
                                    target="_blank"
                                >
                                    Download Agreement
                                </Button>

                            </div>
                        </Card>
                    </Col>

                    {/* ---------------- RIGHT ---------------- */}
                    <Col xs={24} md={12}>
                        <Card
                            size="small"
                            title="Upload Signed Agreement"
                            style={{ height: '100%' }}
                        >
                            {/* Upload Controls */}


                            {/* SIGNED PDF IFRAME */}
                            <div style={{ marginTop: 16, height: IFRAME_HEIGHT }}>
                                {signedUrl ? (
                                    <iframe
                                        src={signedUrl}
                                        title="Signed Agreement"
                                        width="100%"
                                        height={IFRAME_HEIGHT}
                                        style={{
                                            border: '1px solid #E5E7EB',
                                            borderRadius: 8,
                                        }}
                                    />
                                ) : (
                                    <Text type="secondary">Signed agreement not uploaded yet</Text>
                                )}
                            </div>

                            {/* DOWNLOAD (ALIGNED SAME POSITION AS LEFT) */}
                            <div style={{ textAlign: 'center', marginTop: 10 }}>
                                <Button
                                    type="primary"
                                    ghost
                                    size="large"
                                    href={signedUrl}
                                    target="_blank"
                                >
                                    Download Signed Agreement
                                </Button>

                            </div>

                            <Space direction="vertical" size="large" style={{ width: '100%', marginTop: 24 }}>
                            <Upload
                                    accept="application/pdf"
                                    beforeUpload={(file) => {
                                        setFile(file);
                                        return false;
                                    }}
                                    maxCount={1}
                                    showUploadList
                                >
                                    <Button icon={<UploadOutlined />}>Select Signed PDF</Button>
                                </Upload>

                                {file && <Text>Selected: {file.name}</Text>}

                                <Button
                                    type="primary"
                                    onClick={handleUpload}
                                    loading={uploading}
                                    disabled={!file}
                                    block
                                >
                                    Upload Signed PDF
                                </Button>
                            </Space>
                        </Card>

                    </Col>

                </Row>
            </Card>
        </div>
    );
};

export default BookingAgreement;
